import React from 'react'
import _ from 'lodash'

import {
    Card,
    H3,
    H5
} from '../../../../components/UI/index.js'
import {
    formSpacing,
    FormStack,
    Toggle,
    TimePicker
} from '../../../../components/UI/forms/index.js'

class OpeningHours extends React.Component {
    onChangeChecked(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.checked)

        this.props.onChange(reseller, path)
    }

    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.value)

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller, path)
    }

    render() {
        const {reseller} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>Openingstijden</H3>

                <H5 style={{marginBottom: 24}}>Open</H5>

                <FormStack style={{marginBottom: formSpacing.section + formSpacing.rowGap}}>
                    {_.keys(days).map((day) => {
                        return (
                            <div key={day} style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap}}>

                                <Toggle
                                    style={{flex: 1}}
                                    label={days[day]}
                                    checked={reseller.settings.account && reseller.settings.account.openingHours[day].open}
                                    onChange={this.onChangeChecked.bind(this, `account.openingHours.${day}.open`)}
                                />

                                <div key={day} style={{display: 'flex', columnGap: formSpacing.columnGap}}>
                                    <TimePicker
                                        label='Van'
                                        disabled={!(reseller.settings.account && reseller.settings.account.openingHours[day].open)}
                                        style={{width: 130}}
                                        value={reseller.settings.account && reseller.settings.account.openingHours[day] ? reseller.settings.account.openingHours[day].from : '00:00'}
                                        onChange={this.onSaveValue.bind(this, `account.openingHours.${day}.from`)}
                                    />
                                    <TimePicker
                                        label='Tot'
                                        disabled={!(reseller.settings.account && reseller.settings.account.openingHours[day].open)}
                                        style={{width: 130}}
                                        value={reseller.settings.account && reseller.settings.account.openingHours[day] ? reseller.settings.account.openingHours[day].till : '00:00'}
                                        onChange={this.onSaveValue.bind(this, `account.openingHours.${day}.till`)}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 24}}>Gesloten</H5>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    {_.keys(holidays).map((day) => {
                        return (
                            <Toggle
                                key={day}
                                label={holidays[day]}
                                checked={reseller.settings.account && reseller.settings.account.openingHours.closed[day]}
                                onChange={this.onChangeChecked.bind(this, `account.openingHours.closed.${day}`)}
                            />
                        )
                    })}
                </FormStack>
            </Card>
        )
    }
}

const days = {
    monday: 'Maandag',
    tuesday: 'Dinsdag',
    wednesday: 'Woensdag',
    thursday: 'Donderdag',
    friday: 'Vrijdag',
    saturday: 'Zaterdag',
    sunday: 'Zondag'
}

const holidays = {
    nieuwjaarsdag: 'Nieuwjaarsdag',
    koningsdag: 'Koningsdag',
    goedeVrijdag: 'Goede vrijdag',
    eerstePaasdag: 'Eerste Paasdag',
    tweedePaasdag: 'Tweede Paasdag',
    dagvdarbeid: 'Dag van de arbeid (1 mei)',
    bevrijdingsdag: 'Bevrijdingsdag',
    hemelvaartsdag: 'Hemelvaarstdag',
    pinksteren: 'Pinksteren',
    pinkstermaandag: 'Pinkstermaandag',
    eersteKerstdag: 'Eerste Kerstdag',
    tweedeKerstdag: 'Tweede Kerstdag'
}

export default OpeningHours
